import Vue from 'vue'
import VueRouter from 'vue-router'
import Calculadora from '../views/Calculadora.vue'
import About from '../views/About.vue'
import Instrucciones from '../views/Instrucciones.vue'
import Resultados from '../views/Resultados.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Calculadora',
    component: Calculadora
  },
  {
    path: '/about',
    name: 'About',
    component: About
  },
  {
    path: '/instrucciones',
    name: 'Instrucciones',
    component: Instrucciones
  },
  {
    path: '/resultados',
    name: 'Resultados',
    component: Resultados
  }
]

const router = new VueRouter({
  routes
})

export default router
